var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"window",class:{'show-grid': _vm.$slots.title && _vm.$slots.body}},[(_vm.$slots.title)?_c('div',{staticClass:"title clearfix"},[_vm._t("title")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"body clearfix"},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }